import { Link } from "react-router-dom";
import { CONTACT, NAV } from "../../lib/catalog";

const link = "hover:text-[#A0216B] transition-colors duration-300";

export const Footer = () => (
  <footer className="relative overflow-hidden border-t border-[#240620]/10 bg-[#FEFDEB] pt-12 text-[#4a2443]" data-testid="site-footer">
    <div className="mx-auto grid max-w-[1440px] gap-8 px-5 sm:px-8 md:grid-cols-12">
      <div className="md:col-span-5">
        <Link to="/" className="inline-block" data-testid="footer-logo">
          <img src="/brand/logo-tight.webp?v=4" alt="PetalBasket" className="h-24 w-auto sm:h-28" />
        </Link>
        <p className="mt-4 max-w-sm font-display text-2xl italic text-[#240620]">Celebrate every moment with flowers.</p>
        <div className="mt-6 flex flex-wrap gap-x-6 gap-y-2 text-sm font-medium">
          <Link to={{ pathname: "/", hash: "about" }} className={link} data-testid="footer-about-link">About us</Link>
          <Link to={{ pathname: "/", hash: "faqs" }} className={link} data-testid="footer-faq-link">FAQs</Link>
          <Link to="/booking-list" className={link} data-testid="footer-booking-link">Booking list</Link>
          <Link to={{ pathname: "/", hash: "enquire" }} className={link}>Contact</Link>
        </div>
      </div>
      <div className="md:col-span-3">
        <p className="font-cinzel text-[11px] tracking-[0.3em] text-[#A0216B]">Collection</p>
        <ul className="mt-4 space-y-2 text-sm">
          {NAV.map((c) => <li key={c.slug}><Link to={`/c/${c.slug}`} className={link} data-testid={`footer-link-${c.slug}`}>{c.name}</Link></li>)}
        </ul>
      </div>
      <div className="space-y-3 text-sm md:col-span-4">
        <p className="font-cinzel text-[11px] tracking-[0.3em] text-[#A0216B]">Contact</p>
        <p><a href={`tel:${CONTACT.tel}`} className={link}>{CONTACT.phone}</a></p>
        <p><a href={`mailto:${CONTACT.email}`} className={link}>{CONTACT.email}</a></p>
        <p className="pt-2 font-semibold text-[#240620]">Three days prior booking required for home delivery.</p>
      </div>
    </div>
    <p className="pointer-events-none mt-8 select-none whitespace-nowrap text-center font-display text-[14vw] font-semibold italic leading-[0.8] text-outline-plum" aria-hidden>PetalBasket</p>
    <p className="mt-4 text-center font-cinzel text-xs tracking-[0.35em] text-[#A0216B] sm:text-sm" data-testid="footer-by-leofair">by LeoFair Events &amp; Entertainments</p>
    <div className="mt-6 bg-[#240620] text-[#E8D8C8]">
      <div className="mx-auto flex max-w-[1440px] flex-col gap-2 px-5 py-5 text-xs sm:flex-row sm:justify-between sm:px-8">
        <span data-testid="footer-copyright">© 2026 LeoFair Events &amp; Entertainments, All rights reserved.</span>
        <Link to="/admin" className="hover:text-[#FFF8EF]" data-testid="footer-admin-link">Admin login</Link>
      </div>
    </div>
  </footer>
);
